"use client";

import type { ReactNode } from "react";
import { useAuthProfile, useRoleImpersonation } from "@/lib/auth-context";
import { hasPermission } from "@/lib/users-rbac";

/** Renders children only when the actor has `permission`; otherwise a denied panel. */
export function RequirePermission({
  permission,
  children,
  title = "Permission required",
  message = "You do not have access to this area.",
}: {
  permission: string;
  children: ReactNode;
  title?: string;
  message?: string;
}) {
  const profile = useAuthProfile();
  const { impersonation } = useRoleImpersonation();
  if (!hasPermission(profile?.permissions, permission)) {
    const impersonatingUsers =
      Boolean(impersonation) && permission === "users.view";
    return (
      <div className="users-denied" role="alert">
        <h2>{title}</h2>
        <p>
          {impersonatingUsers
            ? "Exit role preview to continue managing users and roles."
            : message}
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
